(function () {
  angular.module("akitabox.core.root").run(states);

  /* @ngInject */
  function states(Router) {
    Router.configureStates([
      {
        state: "root",
        config: {
          abstract: true,
          templateUrl: "app/core/modules/root/root.html",
        },
      },
      {
        state: "root.privacyPolicy",
        config: {
          url: "/privacy-policy",
          templateUrl: "app/core/modules/root/templates/privacy-policy.html",
          data: {
            pageTitle: "Privacy Policy",
          },
        },
      },
      {
        state: "root.termsOfUse",
        config: {
          url: "/terms-of-use",
          templateUrl: "app/core/modules/root/templates/terms-of-use.html",
          data: {
            pageTitle: "Terms of Use",
          },
        },
      },
      {
        state: "root.upgradeBrowser",
        config: {
          controller: "UpgradeBrowserController",
          controllerAs: "vm",
          url: "/upgrade-browser",
          templateUrl: "app/core/modules/root/templates/upgrade-browser.html",
        },
      },
      {
        state: "root.503",
        config: {
          templateUrl: "app/core/modules/root/templates/503.html",
        },
      },
      {
        state: "root.404",
        config: {
          templateUrl: "app/core/modules/root/templates/404.html",
        },
      },
    ]);
  }
})();
